var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSlider',_vm._b({attrs:{"value":_vm.value,"min":0,"max":100,"interval":0.001,"lazy":true,"contained":true,"dot-options":{tooltip: 'none'}},on:{"change":_vm.onInput}},'VueSlider',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }